module.exports = __webpack_public_path__ + "static/media/modulo-arithmetics.5e6d8ac7.mp4";